import { defineConnectorConstellationDerivation, defineConnectorItemDerivation, toConnectorItemCollectionDerivation } from '@toolproof-core/visualization/derivation/_pure/derivation-values';
import { buildLineGuideShape } from '@toolproof-core/visualization/_pure/shapes';
import { toNodeItemKey } from '../keyCodec';
import type { deriveRingTree } from './ringTree';

export function deriveRingTreeRadials(ring: ReturnType<typeof deriveRingTree>, directoryColor: string) {
    const itemCollectionKey = 'collection:connector:core:ring-tree-radials';
    const items = toConnectorItemCollectionDerivation({
        itemCollectionKey,
        itemDerivations: ring.childRings.map(childRing => {
            const key = toNodeItemKey(childRing.parentPath);
            const start = ring.layout.entryByPath.get(childRing.parentPath)!.position;
            return defineConnectorItemDerivation({
                item: {
                    itemKind: 'connector',
                    itemKey: `item:connector:core:radial:${encodeURIComponent(childRing.parentPath)}`,
                    shape: buildLineGuideShape(),
                    endpoints: { from: { endpointKind: 'static', itemKey: key, anchorKey: 'center' },
                        to: { endpointKind: 'static', itemKey: key, anchorKey: 'center' } },
                },
                parametricState: {
                    endpointPositions: { from: start, to: childRing.center },
                    visualStyle: { color: directoryColor, opacity: 0.5 },
                },
            });
        }),
    });
    const constellation = defineConnectorConstellationDerivation({
        constellation: { constellationKind: 'connector', constellationKey: 'constellation:connector:core:ring-tree-radials', itemCollectionKey },
    });
    return { items, constellation };
}
